
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ExerciseItem } from "./exercise/ExerciseItem";
import { EditExerciseDialog } from "./exercise/EditExerciseDialog";
import { GripVertical } from "lucide-react";

interface Exercise {
  id: string;
  name: string;
  sets: number;
  reps: number;
  weight: number;
  set_data: any[];
  video_url?: string;
  position: number;
  exercise_rest_time?: number;
  set_rest_time?: number;
}

interface ExerciseListProps {
  exercises: Exercise[];
  onDeleteExercise?: (exerciseId: string) => void;
  onUpdateExercise?: (exerciseId: string, field: string, value: number | any[] | string) => void;
  onEditClick?: (exercise: Exercise) => void;
  isEditDialogOpen?: boolean;
  editExerciseName?: string;
  onEditNameChange?: (name: string) => void;
  onEditDialogOpenChange?: (open: boolean) => void;
  showControls?: boolean;
  dragHandleProps?: any;
  isDragging?: boolean;
  isCollapsed?: boolean;
  onCollapseChange?: (collapsed: boolean) => void;
  isLoading?: boolean;
  onSaveExerciseName?: () => void;
  onAddExercise?: () => Promise<void>;
  isPersonalPlan?: boolean;
}

export const ExerciseList = ({
  exercises,
  onDeleteExercise,
  onUpdateExercise,
  onEditClick,
  isEditDialogOpen = false,
  editExerciseName = "",
  onEditNameChange,
  onEditDialogOpenChange,
  showControls = true,
  dragHandleProps,
  isDragging = false,
  isCollapsed = false,
  onCollapseChange,
  isLoading = false,
  onSaveExerciseName,
  onAddExercise,
  isPersonalPlan = false
}: ExerciseListProps) => {
  
  if (isLoading) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        Cargando ejercicios...
      </div>
    );
  }
  
  if (exercises.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        No hay ejercicios en esta rutina
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {exercises.map((exercise) => (
        <ExerciseItem
          key={`exercise-item-stable-${exercise.id}`}
          exercise={exercise}
          onEdit={onEditClick || (() => {})}
          onDelete={onDeleteExercise || (() => {})}
          onUpdate={onUpdateExercise || (() => {})}
          showControls={showControls}
          isDragging={isDragging}
          dragHandleProps={dragHandleProps}
          isCollapsed={isCollapsed}
          onCollapseChange={onCollapseChange}
          isPersonalPlan={isPersonalPlan}
        />
      ))}

      {onEditDialogOpenChange && (
        <EditExerciseDialog
          isOpen={isEditDialogOpen}
          onOpenChange={onEditDialogOpenChange}
          exerciseName={editExerciseName}
          onExerciseNameChange={onEditNameChange || (() => {})}
          onSave={onSaveExerciseName || (() => {})}
        />
      )}
    </div>
  );
};
